import ApiService from './api.service'

const StatementService = {    
  get(meterId, nodeId, recordTypePublicCode, periodFrom, periodTo, page, count, isDeleted) {
    return ApiService.get('api/statements', {
      params: {
        MeterId: meterId,
        NodeId: nodeId,
        RecordTypePublicCode: recordTypePublicCode,
        PeriodFrom: periodFrom,
        PeriodTo: periodTo,
        IsDeleted: isDeleted,
        Page: page,
        Count: count
      }
    })
  },

  getStatementsMeter(meterId, nodeId, recordTypePublicCode, periodFrom, periodTo, page, count, isDeleted) {
    return ApiService.get('api/statements/meter', {
      params: {
        MeterId: meterId,
        NodeId: nodeId,
        RecordTypePublicCode: recordTypePublicCode,
        PeriodFrom: periodFrom,
        PeriodTo: periodTo,
        IsDeleted: isDeleted,
        Page: page,
        Count: count
      }
    })
  },

  getStatementsThermalMeter(meterId, nodeId, recordTypePublicCode, periodFrom, periodTo, page, count, isDeleted) {
    return ApiService.get('api/statements/thermalmeter', {
      params: {
        MeterId: meterId,
        NodeId: nodeId,
        RecordTypePublicCode: recordTypePublicCode,
        PeriodFrom: periodFrom,
        PeriodTo: periodTo,
        IsDeleted: isDeleted,
        Page: page,
        Count: count
      }
    })
  },

  archive(id) {
    return ApiService.put(`/api/statements/archive/${id}`)
  },

  restore(id) {
    return ApiService.put(`/api/statements/restore/${id}`)
  },

  correction(meterId, periodFrom, periodTo, value) {
    let meter = {
      meterId: meterId,
      periodFrom: periodFrom,
      periodTo: periodTo,
      value: value
    }
    return ApiService.put(`/api/statements/correction`, meter)
  },

  insertStatement(meterId, value) {
    let meter = {
      meterId: meterId,
      value: value
    }
    return ApiService.put(`/api/statements/statement`, meter)
  },

  getRecordTypes(meterId) {
    return ApiService.get('/api/statements/record-types', {
      params: {
          MeterId: meterId,
      }
    })
  }
}

export default StatementService